import { IconProps, StyleProps, TextProps } from '@chakra-ui/react';

export const diLogoStyle: IconProps = {
    position: 'absolute',
    top: '26px',
    left: '14px',
    w: '42px',
    h: '42px',
    color: 'white',
};

export const containerStyle: StyleProps = {
    position: 'relative',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
};

export const messageBoxStyle = {
    border: '1px solid',
    borderColor: 'gray.200',
    marginTop: '10%',
    padding: '40px',
};

export const titleStyles: TextProps = {
    fontSize: '35px',
    textAlign: 'center',
    color: 'black',
};

export const messageTextStyles: TextProps = {
    size: 'sm',
    fontSize: 'sm',
    textAlign: 'center',
    maxWidth: '700px',
    margin: 'auto',
    marginTop: '12px',
};

export const exportButtonStyles: TextProps = {
    size: 'small',
    textAlign: 'center',
    color: 'red.500',
    marginTop: '12px',
    textDecoration: 'underline',
    cursor: 'pointer',
};
